(() => {
  if (window.replicaSearchInstalled) return;
  window.replicaSearchInstalled = true;
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-prs-add]');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.busy) return;
    const root = form.closest('[data-replica-search]');
    const button = form.querySelector('button');
    if (button.disabled) return;
    const markup = button.innerHTML;
    form.dataset.busy = 'true';
    button.disabled = true;
    button.textContent = 'ADDING…';
    form.querySelector('.prs-error')?.remove();
    try {
      const response = await fetch(form.action.replace(/\/$/, '') + '.js', {
        method: 'POST', credentials: 'same-origin', body: new FormData(form), headers: { Accept: 'application/json' }
      });
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(result.description || 'Unable to add this item. Please try again.');
      root.querySelector('[data-prs-status]').textContent = 'Added to your bag';
      if (document.querySelector('.replica-cart-controller') && window.replicaCartController) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } else {
        window.location.assign(root.dataset.cartUrl);
      }
    } catch (error) {
      const message = document.createElement('p');
      message.className = 'prs-error';
      message.setAttribute('role', 'alert');
      message.textContent = error.message;
      form.append(message);
    } finally {
      button.innerHTML = markup;
      button.disabled = false;
      delete form.dataset.busy;
    }
  });
})();
